import React from 'react';
import {useQuery} from "@apollo/client";
import {GET_ADVISORS_FOR_WORKSHOP} from "../query";
import {clientV2} from "../../../common";
import {View, Text} from "react-native";

interface IGetAdvisorForWorkshopDataProps {
    children: (advisorList: object[]) => JSX.Element;
    workshopIds: string[];
    client?: any;
    flatlist?: boolean;
}

export const GetAdvisorForWorkshopData = (props: IGetAdvisorForWorkshopDataProps) => {
    const {data, loading, error} = useQuery(GET_ADVISORS_FOR_WORKSHOP, {
        client: props.client ?? clientV2,
        variables: {
            workshopIds: props.workshopIds,
            flatList: props?.flatlist ? props?.flatlist : false,
        },
        fetchPolicy: 'cache-first'
    });
    if (loading || error) return <View><Text>Loading</Text></View>;
    const {getAdvisorsForWorkshop} = data;
    return props.children(getAdvisorsForWorkshop);
};